var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandedList = function SvgExpandedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.357 1.929c.354 0 .643-.29.643-.643V.643A.645.645 0 0 0 17.357 0H.643A.645.645 0 0 0 0 .643v.643c0 .353.29.643.643.643zm0 4.5c.354 0 .643-.29.643-.643v-.643a.645.645 0 0 0-.643-.643H.643A.645.645 0 0 0 0 5.143v.643c0 .353.29.643.643.643z",
    clipRule: "evenodd"
  })));
};
export default SvgExpandedList;